import { render, staticRenderFns } from "./RejectionWOTable.vue?vue&type=template&id=75ed6763&"
import script from "./RejectionWOTable.vue?vue&type=script&lang=js&"
export * from "./RejectionWOTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports